// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcr_a bhj_b bhj_uy bhj_rt bhj_ru bhj_vs","PanelFooter--link":"bcr_b"};